import type {ReactElement} from 'react';
import {assertNever} from '@Utils/assert-never.util';
import {MediaTypePreviewIconType} from './media-type-preview-icon.types';
import type {MediaTypePreviewIconProps} from './media-type-preview-icon.types';

export function MediaTypePreviewIcon({type, className = ''}: MediaTypePreviewIconProps): ReactElement {
  switch (type) {
    case MediaTypePreviewIconType.POST:
      return (
        <svg className={className} width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect x="4" y="4" width="24" height="37" rx="2" fill="#FFFFFF" />
          <rect x="6" y="6" width="20" height="1" rx="0.5" fill="currentColor" />
          <rect x="6" y="8" width="7" height="1" rx="0.5" fill="currentColor" />
          <rect x="6" y="11" width="20" height="28" rx="1" fill="currentColor" />
        </svg>
      );

    case MediaTypePreviewIconType.STORY:
      return (
        <svg className={className} width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect x="4" y="4" width="24" height="37" rx="2" fill="#FFFFFF" />
          <rect x="6" y="6" width="6" height="1" rx="0.5" fill="currentColor" />
          <rect x="13" y="6" width="6" height="1" rx="0.5" fill="currentColor" />
          <rect x="20" y="6" width="6" height="1" rx="0.5" fill="currentColor" />
          <rect x="6" y="9" width="20" height="30" rx="1" fill="currentColor" />
        </svg>
      );

    case MediaTypePreviewIconType.BOTH:
      return (
        <svg className={className} width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect x="4" y="7.66" width="12.66" height="19.51" rx="1.22" fill="#FFFFFF" />
          <rect x="5.22" y="8.88" width="10.22" height="0.53" rx="0.26" fill="currentColor" />
          <rect x="5.22" y="9.93" width="3.69" height="0.53" rx="0.26" fill="currentColor" />
          <rect x="5.22" y="11.51" width="10.22" height="14.44" rx="0.53" fill="currentColor" />
          <rect x="13.62" y="4" width="15.03" height="23.17" rx="1.22" fill="#FFFFFF" />
          <rect x="14.84" y="5.22" width="3.78" height="0.63" rx="0.31" fill="currentColor" />
          <rect x="19.25" y="5.22" width="3.78" height="0.63" rx="0.31" fill="currentColor" />
          <rect x="23.66" y="5.22" width="3.78" height="0.63" rx="0.31" fill="currentColor" />
          <rect x="14.84" y="7.1" width="12.59" height="18.85" rx="0.63" fill="currentColor" />
        </svg>
      );

    default:
      return assertNever(type);
  }
}
